interface Sortable {
  order: number;
}

export const sortItemsByOrder = (a: Sortable, b: Sortable): number =>
  a.order > b.order ? 1 : b.order > a.order ? -1 : 0;
